import React from 'react';
import { BannerCard, PayCripto, ChangeCrypto, CardWirebit, DownloadApp, Footer, NavbarCard} from './Components';

const LandingCard = ({...props}) => {

  return(
    <>
      <NavbarCard {...props}/>
      <div style={{overflowX: 'hidden'}}>
        <BannerCard {...props}/>
        <PayCripto {...props}/>
        <ChangeCrypto {...props}/>
        <CardWirebit {...props}/>
        <DownloadApp {...props}/>
        <Footer {...props}/>
      </div>
    </>
  )
}

export default LandingCard;